export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 1000,
  lg: 1440,
  xl: 1920,
};
